import React from 'react';
import MatchdaySlider from '../MatchdaySlider';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import TablaProm2020 from '../TablaProm2020';
class Campeonato2020 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 1011; i <= 1044; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
	                kits:[],
        kit_path: '/images/kits/todas/',
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
		maxMatchday: 34,

	color2:['#135683','#135683','#135683','#135683','#295e1e','#295e1e','#295e1e','#295e1e',0,0,
              0, 0,0,0,0,'#835612',0,'#ff3355'],

	table2: [],



	 table1:[
		{'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pts19':53, 'pon19':1.325,'pts20':65,'pon20':0.765,'pon':2.09},
		{'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pts19':37, 'pon19':0.888,'pts20':57,'pon20':0.671,'pon':1.559},
		 {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pts19':38, 'pon19':0.95,'pts20':51,'pon20':0.6,'pon':1.55},
		{'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pts19':40, 'pon19':1,'pts20':39,'pon20':0.459,'pon':1.459},
		{'color':0,'shortname':'union', 'rivalName':'U. Española', 'pts19':34, 'pon19':0.816,'pts20':52,'pon20':0.612,'pon':1.428},
		{'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pts19':34, 'pon19':0.85,'pts20':46,'pon20':0.541,'pon':1.391},
		{'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pts19':34, 'pon19':0.85,'pts20':45,'pon20':0.529,'pon':1.379},
		{'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pts19':34, 'pon19':0.816,'pts20':47,'pon20':0.553,'pon':1.369},
              {'color':0,'shortname':'audax', 'rivalName':'Audax Italiano', 'pts19':34, 'pon19':0.85,'pts20':41,'pon20':0.482,'pon':1.332},
		{'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pts19':0, 'pon19':0,'pts20':44,'pon20':1.294,'pon':1.294},
		{'color':0,'shortname':'coquimbo', 'rivalName':'Coquimbo U.', 'pts19':34, 'pon19':0.85,'pts20':35,'pon20':0.412,'pon':1.262},
		{'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pts19':27, 'pon19':0.675,'pts20':48,'pon20':0.565,'pon':1.24},
		{'color':0,'shortname':'everton', 'rivalName':'Everton', 'pts19':29, 'pon19':0.725,'pts20':43,'pon20':0.506,'pon':1.231},
		 {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pts19':24, 'pon19':0.6,'pts20':52,'pon20':0.612,'pon':1.212},
		{'color':0,'shortname':'curico', 'rivalName':'Curicó', 'pts19':26, 'pon19':0.65,'pts20':46,'pon20':0.541,'pon':1.191},
		{'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pts19':0, 'pon19':0,'pts20':39,'pon20':1.147,'pon':1.147},
		{'color':'#835612','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pts19':23, 'pon19':0.575,'pts20':41,'pon20':0.482,'pon':1.057},
              {'color':'#E42727','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pts19':25, 'pon19':0.6,'pts20':38,'pon20':0.447,'pon':1.047}],
    };

  }

  componentDidMount() {
	this.getKits();
	this.getStandings();
	}


generateTable(fixture, json){

let result = [];
const lastTable = json[fixture].table;
console.log(lastTable);
lastTable.forEach(team => {
  console.log(team.team, team.points);
  result.push({
    shortname: team.name,
    pj: team.played,
    pg: team.won,
    pe: team.drawn,
    pp: team.lost,
    gf: team.goals_for,
    gc: team.goals_against,
    dif: team.goal_difference,
    pts: team.points,
    rivalName: team.team
  });
});

return result;

}


handleMatchdayChange = (day) => {
    console.log("Selected matchday:", day);



        let newtable2 = this.generateTable(day-1,this.state.standings);

        let sortednewtable2 = this.sortTable(newtable2);


        for (let i = 0; i < sortednewtable2.length; i++) {
                sortednewtable2[i].color = this.state.color2[i];
        }
        this.setState({table2:sortednewtable2});


  };




 getStandings(){

        fetch("https://www.registrosudec.com:5000/standings", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: 63
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)

        let standingsObj = result['standings'];
        let regular = standingsObj[0];
        console.log("regular");
        console.log(regular);
        this.setState({
        standings: regular['standings_history']}) //[json1, json2,...]


        let newtable2 = this.generateTable(33,regular['standings_history']);

        let sortednewtable2 = this.sortTable(newtable2);


        for (let i = 0; i < sortednewtable2.length; i++) {
                sortednewtable2[i].color = this.state.color2[i];
        }
        this.setState({table2:sortednewtable2});



    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].pg === table[j+1].pg) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].pg === table[j+1].pg) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}



render(){


  let subT = this.subText('#295e1e', 'Clasificado a Sudamericana 2021');
  let subC = this.subText('#135683', 'Clasificado a Libertadores 2021');
  let subP = this.subText('#835612', 'Juega Liguilla Promoción');
  let subD = this.subText('#E42727', 'Desciende a Primera B');
  return(

	<div style={{textAlign: 'center' }}>

	 <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Campeonato 2020</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>
	<div style={{ height: '50px' }}></div>
	<div>
	<span>Evolución de la tabla</span>
      <MatchdaySlider maxMatchday={this.state.maxMatchday} onChange={this.handleMatchdayChange} />
    </div>

	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
	<div style={{ height: '10px' }}></div>
	{subC}
	{subT}
	{subP}
 	{subD}

	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos"> Tabla Promedios 2019-20</div>
        <div style={{ height: '10px' }}></div>
	{<TablaProm2020 teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>
	{subP}
        {subD}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Campeonato 2020</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Campeonato 2020</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Campeonato 2020" />
     </div>


  )
}

}
export default Campeonato2020;
